<template>
  <div id="loginByWxWeb" v-loading="loading">
    <div style="padding: 50px 20px;text-align: center;color:#999;font-size: 12px;">
      <div>微信登录</div>
      <div>WeChart Login</div>
    </div>
  </div>
</template>
  
<script>
import API_Soft from '@/api/soft.js'
export default {
  name: 'TenantLoginByWxWeb',
  components: {},
  data() {
    return {
      loading: false,
      code: '',
      state: '',
      softList: []
    }
  },
  watch: {},
  computed: {},
  mounted() {
    console.log('mounted query', this.$route.query)
    if (this.$route.query && this.$route.query.code) {
      this.code = this.$route.query.code || ''
      this.state = this.$route.query.state || ''
      this.getSoftList()
    }
  },
  created() {},
  methods: {
    getSoftList() {
      this.loading = true
      API_Soft.getList({}).then(res => {
        console.log('getSoftList', res.data)
        let arr = res.data.filter(m => m.licenseCode == this.state)
        if (arr.length != 1) {
          console.log('softFindsNotOne', this.state, arr)
        } else {
          let soft = arr[0]
          console.log('soft', soft)
          //webUrl=https://dn.jiandanke.cn/web#"
          let url = `${soft.webUrl}/login?code=${this.code}&loginType=wx`
          console.log('url', url)
          window.location.href = url
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// .app-top {
//   margin-top: 58px;
// }
</style>

<style lang="scss">
#loginByWxWeb {
  @media screen and (max-width: 576px) {
    // #regBindBook {
    //   .el-form-item {
    //     margin-bottom: 20px;
    //   }
    //   .el-form--label-top .el-form-item__label {
    //     line-height: 20px;
    //   }
    //   .el-form--label-top .el-form-item__label {
    //     padding: 0;
    //   }
    // }
  }
}
</style>